export default function AppSection() {
  const appFeatures = [
    { icon: 'ri-smartphone-line', text: '手机浏览器即开即看' },
    { icon: 'ri-hd-line', text: '高清画质自适应' },
    { icon: 'ri-download-line', text: '离线缓存功能' },
    { icon: 'ri-notification-3-line', text: '更新实时提醒' },
  ];

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
                移动观影
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                无需下载APP，手机浏览器直接访问农民影视即可畅享高清影视内容。网站已全面适配移动设备，自适应屏幕尺寸与分辨率，让你随时随地都能获得流畅的免费高清影视在线观看体验。
              </p>

              <div className="grid grid-cols-2 gap-3 mb-6">
                {appFeatures.map((feat) => (
                  <div key={feat.text} className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className={`${feat.icon} text-sm`}></i>
                    </div>
                    <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">{feat.text}</span>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-3">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line"></i>
                  立即体验
                </a>
                <span className="text-xs text-foreground-500">无需安装，即开即看</span>
              </div>
            </div>

            <div className="flex-1 w-full lg:w-auto p-6 md:p-8 lg:p-0">
              <div className="max-w-xs mx-auto">
                <div className="relative bg-gradient-to-br from-background-200 to-background-100 rounded-3xl p-3 shadow-lg">
                  <div className="bg-black rounded-2xl overflow-hidden">
                    <div className="h-8 bg-black flex items-center justify-center">
                      <div className="w-16 h-1 bg-white/20 rounded-full"></div>
                    </div>
                    <div className="aspect-[9/16] bg-gradient-to-b from-primary-900 to-foreground-950 flex flex-col items-center justify-center p-6 text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-primary-500 rounded-2xl mb-4">
                        <i className="ri-movie-2-line text-2xl text-white"></i>
                      </div>
                      <span className="text-white font-heading text-base mb-2">农民影视</span>
                      <span className="text-white/50 text-xs">免费高清影视</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}